/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import { CommonIconsInterface } from "components/icons/common";

const DuplicateIcon = ({
  size = "small",
  color = "currentColor",
  className,
}: CommonIconsInterface) => {
  let iconSizeClassName;
  if (size === "small") {
    iconSizeClassName = "w-5 h-5";
  } else {
    iconSizeClassName = "w-7 h-7";
  }

  return (
    <svg
      className={cn(className, iconSizeClassName)}
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="UK3i_x23"
    >
      <rect
        x="3.66602"
        y="6.6001"
        width="11"
        height="11"
        rx="1.46667"
        fill={color}
        test-id="fuhQPEeK"
      />

      <path
        d="M7.33398 5.13317V4.92365C7.33398 4.22935 7.89683 3.6665 8.59113 3.6665H16.3435C17.0378 3.6665 17.6007 4.22935 17.6007 4.92365V13.4094C17.6007 14.1037 17.0378 14.6665 16.3435 14.6665H16.134"
        stroke={color}
        strokeWidth="1.17857"
        test-id="6SssnRl0"
      />
    </svg>
  );
};

export default DuplicateIcon;
